import type { themeVars } from '@shieldpay/theme-provider-ui/theme/contract';
import { classFilter } from '@shieldpay/theme-provider-ui/utilities';

import BrazilFlagSrc from '../../../images/brazil.svg';
import CanadaFlagSrc from '../../../images/canada.svg';
import EuropeanUnionFlagSrc from '../../../images/european-union.svg';
import SwitzerlandFlagSrc from '../../../images/switzerland.svg';
import UnitedKingdomFlagSrc from '../../../images/united-kingdom.svg';
import UnitedStatesFlagSrc from '../../../images/united-states.svg';
import { Box } from '../box/box';

import * as styles from './country-flags.css';

export type IconSize = keyof typeof themeVars.iconSizes;

interface FlagIconProps {
  src: string;
  alt: string;
  size?: IconSize;
}

const FlagIcon = ({ size = 'm', ...props }: FlagIconProps) => (
  <Box
    Component="span"
    variant="initial"
    padding="baseNeg7"
    className={classFilter([styles.iconWrapper, styles.iconSize[size]])}
  >
    <img {...props} className={classFilter([styles.icon])} />
  </Box>
);

export const UnitedKingdom = ({
  alt,
  size,
}: {
  alt: string;
  size?: IconSize;
}) => {
  return <FlagIcon src={UnitedKingdomFlagSrc} alt={alt} size={size} />;
};
export const UnitedStates = ({
  alt,
  size,
}: {
  alt: string;
  size?: IconSize;
}) => {
  return <FlagIcon src={UnitedStatesFlagSrc} alt={alt} size={size} />;
};
export const Switzerland = ({
  alt,
  size,
}: {
  alt: string;
  size?: IconSize;
}) => {
  return <FlagIcon src={SwitzerlandFlagSrc} alt={alt} size={size} />;
};
export const EuropeanUnion = ({
  alt,
  size,
}: {
  alt: string;
  size?: IconSize;
}) => {
  return <FlagIcon src={EuropeanUnionFlagSrc} alt={alt} size={size} />;
};
export const Canada = ({ alt, size }: { alt: string; size?: IconSize }) => {
  return <FlagIcon src={CanadaFlagSrc} alt={alt} size={size} />;
};
export const Brazil = ({ alt, size }: { alt: string; size?: IconSize }) => {
  return <FlagIcon src={BrazilFlagSrc} alt={alt} size={size} />;
};
